/**
 * Google Tag Manager Helper for Enhanced Conversion Tracking
 * Pushes hashed user data to dataLayer for Google Ads enhanced conversions
 */

async function sha256(input) {
  const data = new TextEncoder().encode(input.trim().toLowerCase());
  const hash = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

function normalizePhone(phone) {
  const digits = phone.replace(/\D/g, "");
  const withCountry = digits.length === 10 ? "1" + digits : digits;
  return "+" + withCountry;
}

export async function pushFormSubmitEvent(email, phone) {
  const userData = {};

  if (email) {
    userData.sha256_email_address = await sha256(email);
  }
  if (phone) {
    userData.sha256_phone_number = await sha256(normalizePhone(phone));
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "form_submit",
    form_name: "contact_form",
    user_data: userData,
  });
}
